<script lang="ts">
  import { getServices } from '../../app/context';
  import { docProgress } from '../../model/stats';
  import { format } from '../../strings';

  /** `wide` stretches the bar to fill the row (mobile toolbar). */
  let { class: className, wide = false }: { class?: string; wide?: boolean } = $props();

  const { store } = getServices();
  const progress = $derived(docProgress(store.doc));
  const percent = $derived(progress.total === 0 ? 0 : (progress.rated / progress.total) * 100);
</script>

<div
  class={[
    'flex h-9 items-center gap-2 rounded-lg border border-line-strong/50 bg-surface px-3 text-xs font-medium whitespace-nowrap text-ink-muted tabular-nums pointer-coarse:h-11',
    className,
  ]}
>
  <span
    class={['relative h-1.5 overflow-hidden rounded-full bg-line', wide ? 'flex-1' : 'w-10']}
    aria-hidden="true"
  >
    <span class="absolute inset-y-0 left-0 rounded-full bg-accent" style:width="{percent}%"></span>
  </span>
  {format.progress(progress.rated, progress.total)}
</div>
